export const levels = [
  {
    level: 0,
    name: "No contributions.",
  },
  {
    level: 1,
    name: "Low contributions.",
  },
  {
    level: 2,
    name: "Medium-low contributions.",
  },
  {
    level: 3,
    name: "Medium-high contributions.",
  },
  {
    level: 4,
    name: "High contributions.",
  },
];

// Day name labels
export const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
